"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../data/constants");
var abstractComponent_1 = __importDefault(require("./abstractComponent"));
var VideoControls = /** @class */ (function (_super) {
    __extends(VideoControls, _super);
    function VideoControls(selector) {
        var _this = _super.call(this) || this;
        _this.selector = selector;
        _this.videoContainer = document.querySelectorAll(_this.selector);
        if (_this.videoContainer.length < 1)
            return _this;
        _this.videoControls = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS, "]"));
        _this.videoControlVideo = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_FILE, "]"));
        _this.videoControlVideo = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_FILE, "]"));
        _this.videoControlPlay = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS_PLAY, "]"));
        _this.videoControlPause = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS_PAUSE, "]"));
        _this.videoControlBar = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS_BAR, "]"));
        _this.videoFullscreen = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS_FULLSCREEN, "]"));
        _this.progress = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS_PROGRESS, "]"));
        _this.progressBar = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS_PROGRESS_BAR, "]"));
        _this.videoTimeStart = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS_CONTROLS_TIME_START, "]"));
        _this.videoTimeEnd = document.querySelectorAll("[".concat(constants_1.DATA_VIDEO_CONTROLS_CONTROLS_TIME_END, "]"));
        // Configure each Custom VideoControl on Videos
        _this.videoContainer.forEach(function (element, index) {
            var video = _this.videoControlVideo[index];
            var play = _this.videoControlPlay[index];
            var controlBar = _this.videoControlBar[index];
            var fullscreen = _this.videoFullscreen[index];
            var progress = _this.progress[index];
            var progressBar = _this.progressBar[index];
            var videoTimeStart = _this.videoTimeStart[index];
            var videoTimeEnd = _this.videoTimeEnd[index];
            // Display the first Frame of a video
            if (video.getAttribute('video-autoplay') === '0' || !video.getAttribute('video-autoplay')) {
                var videoSrc = video.firstElementChild.getAttribute('src');
                video.firstElementChild.setAttribute('src', videoSrc + '#t=0.5');
            }
            // Display the user defined video controls
            _this.videoControls[index].setAttribute('data-state', 'visible');
            var supportsProgress = (document.createElement('progress').max !== undefined);
            if (!supportsProgress) {
                _this.progress[index].setAttribute('data-state', 'fake');
            }
            if (!(document === null || document === void 0 ? void 0 : document.fullscreenEnabled) && !(document === null || document === void 0 ? void 0 : document.webkitfullscreenEnabled) && !(document === null || document === void 0 ? void 0 : document.mozfullscreenEnabled)) {
                fullscreen.style.display = 'none';
                controlBar.classList.add('no-fullscreen');
            }
            _this.videoControlPlay[index].addEventListener('click', function (e) {
                if (video.paused || video.ended) {
                    video.play();
                    play.classList.add('is-hidden');
                    controlBar.classList.remove('is-hidden');
                    var videoDuration = new Date(video.duration * 1000).toISOString().substr(15, 4);
                    videoTimeEnd.innerHTML = (videoDuration.toString());
                }
            });
            _this.videoControlPause[index].addEventListener('click', function (e) {
                video.pause();
                play.classList.remove('is-hidden');
                controlBar.classList.add('is-hidden');
            });
            video.addEventListener('loadedmetadata', function () {
                progress.setAttribute('max', video.duration.toString());
            });
            _this.progress[index].addEventListener('click', function (e) {
                var pos = (e.pageX - (this.offsetLeft)) / this.offsetWidth;
                video.currentTime = pos * video.duration;
            });
            // IOS Mobile handle close Fullscreen
            video.addEventListener('webkitendfullscreen', function (e) {
                video.pause();
                play.classList.remove('is-hidden');
                controlBar.classList.add('is-hidden');
            });
            fullscreen.addEventListener('click', function (e) {
                handleFullscreen();
            });
            video.addEventListener('timeupdate', function () {
                progress.setAttribute('max', video.duration.toString());
                progress.setAttribute('value', video.currentTime.toString());
                progressBar.style.width = "".concat(Math.floor(video.currentTime * 100 / video.duration), "%");
                var currentTime = new Date(video.currentTime * 1000).toISOString().substr(15, 4);
                videoTimeStart.innerHTML = (currentTime.toString());
                if (video.ended) {
                    play.classList.remove('is-hidden');
                    controlBar.classList.add('is-hidden');
                }
            });
            progress.addEventListener('click', function (e) {
                var rect = progress.getBoundingClientRect();
                var pos = (e.pageX - rect.left) / progress.offsetWidth;
                video.currentTime = pos * video.duration;
            });
            function handleFullscreen() {
                if (document.fullscreenElement !== null) {
                    // The document is not in fullscreen mode
                    document.exitFullscreen();
                    setFullscreenData('false');
                }
                else {
                    // The document is in fullscreen mode
                    element.requestFullscreen();
                    setFullscreenData('true');
                }
            }
            function setFullscreenData(state) {
                if (state == 'true') {
                    element.classList.add('fullscreen');
                }
                else {
                    element.classList.remove('fullscreen');
                }
                element.setAttribute('data-fullscreen', state);
            }
            document.addEventListener('fullscreenchange', function () {
                if (document.fullscreenElement) {
                    setFullscreenData('true');
                }
                else {
                    setFullscreenData('false');
                }
            });
        });
        return _this;
    }
    return VideoControls;
}(abstractComponent_1.default));
exports.default = VideoControls;
